import Model from '~/models/Model';

export default class Alert extends Model {
  resource() {
    return 'v1/alerts';
  }
}
